(() => {
  const root = document.querySelector('[data-d2-navigation]');
  if (!root || root.dataset.ready) return;
  const dialog = root.querySelector('[data-d2-nav-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  root.dataset.ready = 'true';
  const bar = root.querySelector('[data-d2-bottom-nav]');
  const dock = root.querySelector('[data-d2-nav-dock]');
  const dialogDock = root.querySelector('[data-d2-nav-dialog-dock]');
  const heading = root.querySelector('[data-d2-nav-title]');
  const scroller = root.querySelector('[data-d2-nav-scroll]');
  const triggers = [...root.querySelectorAll('[data-d2-nav-open]')];
  const tabs = root.querySelector('[data-d2-nav-tabs]');
  const switches = [...root.querySelectorAll('[data-d2-nav-switch]')];
  const mobile = matchMedia('(max-width: 749px)');
  const desktopChat = root.querySelector('[data-d2-desktop-chat]');
  let opener;
  let scrollY = 0;
  let restored = true;
  const restore = (focus = true) => {
    if (restored) return;
    restored = true;
    dock.append(bar);
    delete root.dataset.panel;
    dialog.removeAttribute('aria-describedby');
    triggers.forEach(button => button.setAttribute('aria-expanded', 'false'));
    document.documentElement.classList.remove('d2-nav-locked');
    document.documentElement.style.removeProperty('--d2-nav-scroll-y');
    window.scrollTo({ top: scrollY, behavior: 'instant' });
    if (focus) opener?.focus({ preventScroll: true });
  };
  const close = (focus = true) => {
    dialog.close();
    restore(focus);
  };
  triggers.forEach(button => {
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', dialog.id);
    button.setAttribute('aria-expanded', 'false');
  });
  root.addEventListener('click', event => {
    const trigger = event.target.closest('[data-d2-nav-open]');
    const switcher = event.target.closest('[data-d2-nav-switch]');
    if ((trigger || switcher) && (mobile.matches || trigger?.dataset.d2NavOpen === 'whatsapp') && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      const panel = trigger?.dataset.d2NavOpen || switcher.dataset.d2NavSwitch;
      const shopPanel = panel === 'categories' || panel === 'occasions';
      if (trigger && dialog.open && (root.dataset.panel === panel || (panel === 'categories' && root.dataset.panel === 'occasions'))) { close(); return; }
      root.querySelectorAll('[data-d2-nav-panel]').forEach(element => { element.hidden = element.dataset.d2NavPanel !== panel; });
      heading.textContent = heading.dataset[panel];
      if (panel === 'whatsapp') dialog.setAttribute('aria-describedby', 'D2WhatsAppDescription');
      else dialog.removeAttribute('aria-describedby');
      root.dataset.panel = panel;
      tabs.hidden = !shopPanel;
      switches.forEach(button => {
        const selected = button.dataset.d2NavSwitch === panel;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
      triggers.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.d2NavOpen === (shopPanel ? 'categories' : panel))));
      scroller.scrollTop = 0;
      if (trigger) opener = trigger;
      if (!dialog.open) {
        scrollY = window.scrollY;
        restored = false;
        document.documentElement.style.setProperty('--d2-nav-scroll-y', `${-scrollY}px`);
        document.documentElement.classList.add('d2-nav-locked');
        if (mobile.matches) dialogDock.append(bar);
        dialog.showModal();
      }
      if (trigger) heading.focus({ preventScroll: true });
      return;
    }
    const saved = event.target.closest('[data-d2-nav-saved]');
    if (saved) {
      if (dialog.open) close(false);
      const wishlist = document.querySelector('#rosarium-wishlist-drawer');
      wishlist?.open?.({ target: saved });
      return;
    }
    if (event.target.closest('[data-d2-nav-close]')) close();
    else if (dialog.open && event.target.closest('a[href]')) close(false);
  });
  let backdropStart = false;
  dialog.addEventListener('pointerdown', event => { backdropStart = event.target === dialog; });
  dialog.addEventListener('click', event => {
    if (backdropStart && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientY < rect.top || event.clientY > rect.bottom || event.clientX < rect.left || event.clientX > rect.right) close();
    }
    backdropStart = false;
  });
  dialog.addEventListener('close', () => { if (!dialog.open) restore(); });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      close();
      return;
    }
    const tab = event.target.closest('[data-d2-nav-switch]');
    if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      const next = event.key === 'Home' ? switches[0] : event.key === 'End' ? switches.at(-1) : switches[(switches.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + switches.length) % switches.length];
      next.focus();
      next.click();
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')]
      .filter(element => element.getClientRects().length > 0 && element.tabIndex >= 0);
    const first = controls[0];
    const last = controls.at(-1);
    if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
  mobile.addEventListener('change', () => { if (dialog.open) close(false); });
  window.addEventListener('pagehide', () => { if (dialog.open) close(false); });

  // The floating desktop label makes one entrance, then leaves a compact icon.
  if (desktopChat) {
    let hovering = false;
    let idleTimer;
    let minimumTimer;
    let startedAt;
    let initialScrollY;
    let crossedThreshold = false;
    let initialCollapseComplete = false;
    const interacting = () => (hovering && desktopChat.matches(':hover')) || desktopChat.matches(':focus-visible');
    const collapse = () => {
      if (!mobile.matches && !interacting()) root.dataset.chatCollapsed = 'true';
    };
    const finishInitialCollapse = () => {
      if (!initialCollapseComplete) {
        initialCollapseComplete = true;
        collapse();
      }
    };
    const expand = () => {
      delete root.dataset.chatCollapsed;
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(() => {
        initialCollapseComplete = true;
        collapse();
      }, 5000);
    };
    const enter = () => {
      window.clearTimeout(minimumTimer);
      hovering = false;
      startedAt = performance.now();
      initialScrollY = window.scrollY;
      crossedThreshold = false;
      initialCollapseComplete = false;
      expand();
      minimumTimer = window.setTimeout(() => { if (crossedThreshold) finishInitialCollapse(); }, 3000);
    };
    desktopChat.addEventListener('pointerenter', event => {
      if (event.pointerType === 'touch') return;
      hovering = true;
      expand();
    });
    desktopChat.addEventListener('pointerleave', event => {
      if (event.pointerType === 'touch') return;
      hovering = false;
      expand();
    });
    desktopChat.addEventListener('focusin', expand);
    desktopChat.addEventListener('focusout', expand);
    window.addEventListener('scroll', () => {
      if (mobile.matches || initialCollapseComplete || Math.abs(window.scrollY - initialScrollY) < 135) return;
      crossedThreshold = true;
      if (performance.now() - startedAt >= 3000) finishInitialCollapse();
    }, { passive: true });
    mobile.addEventListener('change', enter);
    window.addEventListener('pagehide', () => {
      window.clearTimeout(idleTimer);
      window.clearTimeout(minimumTimer);
    });
    enter();
  }
})();
